import { getNullAvailableResult } from "DependencyResult";
import type {
  DependencyAccessMixedValue,
  DependencyArgument,
  DependencyVisitorContext,
} from "DependencyVisitorContext";
import { isEntity } from "EntityExtensions";
import { DependencyError } from "Errors";
import { getSecurityConditionFunction } from "SecurityConditionFunctions";

export function arbitraryFunc<Mode>(
  funcName: string,
  _: unknown,
  args: DependencyArgument[],
  data: unknown,
  context: DependencyVisitorContext<Mode>,
): DependencyAccessMixedValue<Mode, unknown> {
  const func = getSecurityConditionFunction(funcName);
  if (!func) {
    throw new DependencyError(`Function '${funcName}' is not defined.`);
  }
  if (data == null) {
    return getNullAvailableResult();
  }
  if (Array.isArray(data)) {
    throw new DependencyError("Data is a collection, which is not supported.");
  }
  if (!isEntity(data)) {
    throw new DependencyError("Data must be an entity.");
  }

  return context.strategy.waitAvailable(args, data, context, (args) => func(args, data, context));
}
